<template>
  <div>
    <div v-for="(item, index) in items.data" :key="index">
      <div class="list">
        <div class="l-left">
          <img :src="item.imageUrl" srcset @click="preViewImg(item)" />
          <span>{{ item.quantity }}</span>
        </div>
        <div class="l-right">
          <p class="l-title ellipsis">
            {{ item.customProductTitle }}{{ item.itemStatus }}
          </p>
          <div class="l-style">
            <span v-show="item.option1Name"
              >{{ item.option1Name }}:{{ item.option1Value }}</span
            >
            <span v-show="item.option2Name"
              >{{ item.option2Name }}:{{ item.option2Value }}</span
            >
            <span v-show="item.option3Name"
              >{{ item.option3Name }}:{{ item.option3Value }}</span
            >
          </div>
          <div class="l-sku l-style">
            Sku:{{ item.sku }} | Quantity: {{ item.quantity }}
          </div>
          <div class="l-cost l-style">
            Product cost:${{ item.goodsTotalPrice }}
          </div>
        </div>
      </div>
    </div>
    <div class="shopping" v-if="item.data[0].shippingMethod">
      <h1 class="s-title">Tracking details</h1>
      <p class="shop-item">
        Shipping method: {{ item.data[0].shippingMethod }}
      </p>
      <p class="shop-item">
        Tracking number: {{ item.data[0].trackingNumber }}
      </p>
      <p class="shop-item">Tracking url: {{ item.data[0].trackingUrl }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      items: []
    };
  },
  mounted() {},
  watch: {
    item: {
      immediate: true,
      handler(val) {
        this.items = val;
      }
    }
  },
  methods: {
    preViewImg(item) {
      this.$parent._preViewImg(item);
    }
  }
};
</script>
<style lang="scss" scoped>
.shopping {
  margin-top: 20px;
  font-family: "SourceHanSansSC-regular";
  .s-title {
    font-size: 16px;
    font-family: "SourceHanSansSC-regular";
  }
  .shop-item {
    font-size: 16px;
    font-family: "SourceHanSansSC-regular";
  }
}
.list {
  display: flex;
  margin-top: 20px;
  position: relative;
  button {
    position: absolute;
    top: 10px;
  }
  .l-left {
    width: 100px;
    height: 100px;
    margin-right: 30px;
    position: relative;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
    span {
      display: inline-block;
      color: white;
      width: 20px;
      line-height: 20px;
      height: 20px;
      text-align: center;
      font-size: 14px;
      position: absolute;
      bottom: 0px;
      right: 0px;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
  .l-right {
    margin-right: 0;
    text-align: left;
    .l-title {
      font-size: 18px;
      margin-bottom: 0px;
      font-family: "SourceHanSansSC-regular";
      width: 150px;
    }
    .l-style {
      margin-top: 10px;
      font-size: 13px;
      line-height: 13px;
      color: #999;
      span {
        display: inline-block;
        padding: 0 10px;
        border-right: 1px solid #ddd;
      }
      span:last-child {
        border-right: 0;
      }
      span:first-child {
        padding-left: 0;
      }
    }
  }
}
</style>
